import {
  Badge,
  NumericMarketData,
  OptionData,
  OutOfTheMoney,
  StrategyType,
  Time,
} from "../types";

const formatTo1Decimal = (value: number) => {
  return value?.toFixed(1);
};

export const stockStrategies = [
  /*   {
    id: "cash-extraction-3m",
    label: "Cash Extraction 3m",
    badge: Badge.Neutral,
    triggerInfo:
      "Best for: RSI > 70 (overbought), 1% off 1yr high, Death cross (50/200) - These conditions suggest potential pullbacks where cash extraction can limit downside losses.",
    optionData: {
      strategyType: StrategyType.CashExtraction,
      operations: [
        {
          operationType: "long" as const,
          optionType: "call" as const,
          outOfTheMoney: OutOfTheMoney["5_OUT_OF_THE_MONEY"],
        },
      ],
      time: Time.THREE_MONTHS,
    } satisfies OptionData,
    subtitle: " Replace stock with a long call ",
    description: (data: NumericMarketData) => {
      return `A 3m 5% out of the money is ${formatTo1Decimal(
        data?.["Calls - 5% out of the money 3 month"]
      )} %`;
    },
    value: (data: NumericMarketData) => {
      return data?.["Calls - 5% out of the money 3 month"] < 3;
    },
    valid: (data: NumericMarketData) => {
      const v = data?.["Calls - 5% out of the money 3 month"];
      return v != null && v !== 0;
    },
  }, */
  {
    id: "hedging-3m",
    label: "Hedging 3m",
    badge: Badge.Bear,
    optionData: {
      stockQuantity: 100,
      strategyType: StrategyType.Hedging,
      operations: [
        {
          operationType: "long" as const,
          optionType: "put" as const,
          outOfTheMoney: OutOfTheMoney["5_OUT_OF_THE_MONEY"],
        },
      ],
      time: Time.THREE_MONTHS,
    } satisfies OptionData,
    subtitle: " Hedge against falls with a long put ",
    description: (data: NumericMarketData) => {
      return `A 3m 5% out of the money put is ${formatTo1Decimal(
        data?.["Puts - 5% out of the money 3 month"]
      )} %`;
    },
    value: (data: NumericMarketData) => {
      return data?.["Puts - 5% out of the money 3 month"] < 3;
    },
    valid: (data: NumericMarketData) => {
      const v = data?.["Puts - 5% out of the money 3 month"];
      return v != null && v !== 0;
    },
  },
  /*  {
    id: "synthetic-yield-3m",
    label: "Synthetic Yield 3m",
    badge: Badge.Neutral,
    subtitle: "Generate income on an existing position with a short call",
    optionData: {
      strategyType: StrategyType.SyntheticYield,
      operations: [
        {
          operationType: "short" as const,
          optionType: "call" as const,
          outOfTheMoney: OutOfTheMoney["15_OUT_OF_THE_MONEY"],
        },
      ],
      stockQuantity: 100,
      time: Time.THREE_MONTHS,
    } satisfies OptionData,
    description: (data: NumericMarketData) => {
      return `A 3m 15% out of the money call generates ${formatTo1Decimal(
        data?.["Calls - 15% out of the money 3 month"]
      )} %`;
    },
    value: (data: NumericMarketData) => {
      return data?.["Calls - 15% out of the money 3 month"] > 5;
    },
    valid: (data: NumericMarketData) => {
      const v = data?.["Calls - 15% out of the money 3 month"];
      return v != null && v !== 0;
    },
  },
  {
    id: "synthetic-yield-6m",
    label: "Synthetic Yield 6m",
    badge: Badge.Neutral,
    subtitle: "Generate income on an existing position with a short call ",
    optionData: {
      stockQuantity: 100,
      strategyType: StrategyType.SyntheticYield,
      operations: [
        {
          operationType: "short" as const,
          optionType: "call" as const,
          outOfTheMoney: OutOfTheMoney["15_OUT_OF_THE_MONEY"],
        },
      ],
      time: Time.SIX_MONTHS,
    } satisfies OptionData,
    description: (data: NumericMarketData) => {
      return `A 6m 15% out of the money call generates ${formatTo1Decimal(
        data?.["Calls - 15% out of the money 6 month"]
      )} %`;
    },
    value: (data: NumericMarketData) => {
      return data?.["Calls - 15% out of the money 6 month"] > 10;
    },
    valid: (data: NumericMarketData) => {
      const v = data?.["Calls - 15% out of the money 6 month"];
      return v != null && v !== 0;
    },
  } */
  {
    id: "calls-1m-105c",
    label: "Calls 1m 105%",
    badge: Badge.Bull,
    subtitle: "Additional upside with a long call",
    optionData: {
      strategyType: StrategyType.Calls,
      operations: [
        {
          operationType: "long" as const,
          optionType: "call" as const,
          outOfTheMoney: OutOfTheMoney["5_OUT_OF_THE_MONEY"],
        },
      ],
      time: Time.ONE_MONTH,
    } satisfies OptionData,
    description: (data: NumericMarketData) => {
      return `A 1m 5% out of the money call is ${formatTo1Decimal(
        data?.["Calls - 5% out of the money 1 month"]
      )} %`;
    },
    value: (data: NumericMarketData) => {
      return data?.["Calls - 5% out of the money 1 month"] < 1.5;
    },
    valid: (data: NumericMarketData) => {
      const v = data?.["Calls - 5% out of the money 1 month"];
      return v != null && v !== 0;
    },
  },
  {
    id: "calls-1m-110c",
    badge: Badge.Bull,
    label: "Calls 1m 110%",
    subtitle: "Additional upside with a long call",
    optionData: {
      strategyType: StrategyType.Calls,
      operations: [
        {
          operationType: "long" as const,
          optionType: "call" as const,
          outOfTheMoney: OutOfTheMoney["10_OUT_OF_THE_MONEY"],
        },
      ],
      time: Time.ONE_MONTH,
    } satisfies OptionData,
    description: (data: NumericMarketData) => {
      return `A 1m 10% out of the money call is ${formatTo1Decimal(
        data?.["Calls - 10% out of the money 1 month"]
      )} %`;
    },
    value: (data: NumericMarketData) => {
      return data?.["Calls - 10% out of the money 1 month"] < 0.5;
    },
    valid: (data: NumericMarketData) => {
      const v = data?.["Calls - 10% out of the money 1 month"];
      return v != null && v !== 0;
    },
  },
  {
    id: "calls-spreads-1m-100-110",
    badge: Badge.Bull,
    optionData: {
      strategyType: StrategyType.CallsSpreads,
      operations: [
        {
          operationType: "long" as const,
          optionType: "call" as const,
          outOfTheMoney: OutOfTheMoney["AT_THE_MONEY"],
        },
        {
          operationType: "short" as const,
          optionType: "call" as const,
          outOfTheMoney: OutOfTheMoney["10_OUT_OF_THE_MONEY"],
        },
      ],
      time: Time.ONE_MONTH,
    } satisfies OptionData,
    label: "Calls Spreads 1m 100 // 110",
    subtitle: "Limited upside using a long and short call",
    description: (data: NumericMarketData) => {
      return `A 1m at the money to 10% out of the money call spread is ${formatTo1Decimal(
        10 /
          (data?.["Calls - at the money 1 month"] -
            data?.["Calls - 10% out of the money 1 month"])
      )} times of the cost`;
    },
    value: (data: NumericMarketData) => {
      return (
        10 /
          (data?.["Calls - at the money 1 month"] -
            data?.["Calls - 10% out of the money 1 month"]) >
        3.5
      );
    },
    valid: (data: NumericMarketData) => {
      const v1 = data?.["Calls - at the money 1 month"];
      const v2 = data?.["Calls - 10% out of the money 1 month"];
      return v1 != null && v1 !== 0 && v2 != null && v2 !== 0;
    },
  },
  {
    id: "calls-spreads-3m-105-115",
    badge: Badge.Bull,
    optionData: {
      strategyType: StrategyType.CallsSpreads,
      operations: [
        {
          operationType: "long" as const,
          optionType: "call" as const,
          outOfTheMoney: OutOfTheMoney["5_OUT_OF_THE_MONEY"],
        },
        {
          operationType: "short" as const,
          optionType: "call" as const,
          outOfTheMoney: OutOfTheMoney["15_OUT_OF_THE_MONEY"],
        },
      ],
      time: Time.THREE_MONTHS,
    } satisfies OptionData,
    label: "Calls Spreads 3m 105 // 115",
    subtitle: " Limited upside using a long and short call",
    description: (data: NumericMarketData) => {
      return `A 3m 5% out of the money to 15% out of the money call spread is ${formatTo1Decimal(
        10 /
          (data?.["Calls - 5% out of the money 3 month"] -
            data?.["Calls - 15% out of the money 3 month"])
      )} times of the cost`;
    },

    value: (data: NumericMarketData) => {
      return (
        10 /
          (data?.["Calls - 5% out of the money 3 month"] -
            data?.["Calls - 15% out of the money 3 month"]) >
        4.0
      );
    },
    valid: (data: NumericMarketData) => {
      const v1 = data?.["Calls - 5% out of the money 3 month"];
      const v2 = data?.["Calls - 15% out of the money 3 month"];
      return v1 != null && v1 !== 0 && v2 != null && v2 !== 0;
    },
  },
  {
    id: "puts-1m-95p",
    badge: Badge.Bear,
    optionData: {
      strategyType: StrategyType.Puts,
      operations: [
        {
          operationType: "long" as const,
          optionType: "put" as const,
          outOfTheMoney: OutOfTheMoney["5_OUT_OF_THE_MONEY"],
        },
      ],
      time: Time.THREE_MONTHS,
    } satisfies OptionData,
    label: "Puts 1m 95%",
    subtitle: "Downside protection with a long put",
    description: (data: NumericMarketData) => {
      return `A 1m 5% out of the money put is ${formatTo1Decimal(
        data?.["Puts - 5% out of the money 1 month"]
      )} %`;
    },
    value: (data: NumericMarketData) => {
      return data?.["Puts - 5% out of the money 1 month"] < 1.5;
    },
    valid: (data: NumericMarketData) => {
      const v = data?.["Puts - 5% out of the money 1 month"];
      return v != null && v !== 0;
    },
  },
  {
    id: "puts-1m-90p",
    badge: Badge.Bear,
    label: "Puts 1m 90%",
    optionData: {
      strategyType: StrategyType.Puts,
      operations: [
        {
          operationType: "long" as const,
          optionType: "put" as const,
          outOfTheMoney: OutOfTheMoney["10_OUT_OF_THE_MONEY"],
        },
      ],
      time: Time.ONE_MONTH,
    } satisfies OptionData,
    subtitle: "Downside protection with a long put",
    description: (data: NumericMarketData) => {
      return `A 1m 10% out of the money put is ${formatTo1Decimal(
        data?.["Puts - 10% out of the money 1 month"]
      )} %`;
    },
    value: (data: NumericMarketData) => {
      return data?.["Puts - 10% out of the money 1 month"] < 0.5;
    },
    valid: (data: NumericMarketData) => {
      const v = data?.["Puts - 10% out of the money 1 month"];
      return v != null && v !== 0;
    },
  },
  {
    id: "puts-spreads-1m-100-90",
    badge: Badge.Bear,
    label: "Puts Spreads 1m 100 // 90",
    optionData: {
      strategyType: StrategyType.PutsSpreads,
      operations: [
        {
          operationType: "long" as const,
          optionType: "put" as const,
          outOfTheMoney: OutOfTheMoney["AT_THE_MONEY"],
        },
        {
          operationType: "short" as const,
          optionType: "put" as const,
          outOfTheMoney: OutOfTheMoney["10_OUT_OF_THE_MONEY"],
        },
      ],
      time: Time.ONE_MONTH,
    } satisfies OptionData,
    subtitle: "Limited downside protection using a long and short put",
    description: (data: NumericMarketData) => {
      return `A 1m at the money to 10% out of the money put spread is ${formatTo1Decimal(
        10 /
          (data?.["Puts - at the money 1 month"] -
            data?.["Puts - 10% out of the money 1 month"])
      )} times of the cost`;
    },
    value: (data: NumericMarketData) => {
      return (
        10 /
          (data?.["Puts - at the money 1 month"] -
            data?.["Puts - 10% out of the money 1 month"]) >
        3.5
      );
    },
    valid: (data: NumericMarketData) => {
      const v1 = data?.["Puts - at the money 1 month"];
      const v2 = data?.["Puts - 10% out of the money 1 month"];
      return v1 != null && v1 !== 0 && v2 != null && v2 !== 0;
    },
  },
  {
    id: "puts-spreads-3m-95-85",
    badge: Badge.Bear,
    label: "Puts Spreads 3m 95 // 85",
    optionData: {
      strategyType: StrategyType.PutsSpreads,
      operations: [
        {
          operationType: "long" as const,
          optionType: "put" as const,
          outOfTheMoney: OutOfTheMoney["5_OUT_OF_THE_MONEY"],
        },
        {
          operationType: "short" as const,
          optionType: "put" as const,
          outOfTheMoney: OutOfTheMoney["15_OUT_OF_THE_MONEY"],
        },
      ],
      time: Time.THREE_MONTHS,
    } satisfies OptionData,
    subtitle: "Limited downside protection using a long and short put",
    description: (data: NumericMarketData) => {
      return `A 3m 5% out of the money to 15% out of the money put spread is ${formatTo1Decimal(
        10 /
          (data?.["Puts - 5% out of the money 3 month"] -
            data?.["Puts - 15% out of the money 3 month"])
      )} times of the cost`;
    },
    valid: (data: NumericMarketData) => {
      const v1 = data?.["Puts - 5% out of the money 3 month"];
      const v2 = data?.["Puts - 15% out of the money 3 month"];
      return v1 != null && v1 !== 0 && v2 != null && v2 !== 0;
    },
    value: (data: NumericMarketData) => {
      return (
        10 /
          (data?.["Puts - 5% out of the money 3 month"] -
            data?.["Puts - 15% out of the money 3 month"]) >
        4.0
      );
    },
  },
];
